export const COMPANY = {
  name: "Boston Express Plumbing and Heating LLC",
  short: "Boston Express Plumbing",
  phone: "(781) 355-7190",
  phoneTel: "+17813557190",
  email: "BostonExpressPlumbingOffice@gmail.com",
  address: "3 Cabot Place, Suite 5, Stoughton, MA 02072",
  city: "Stoughton",
  state: "MA",
  zip: "02072",
  serviceArea: "Stoughton, MA",
  yearsExperience: "10+",
  hours: [
    { day: "Monday – Friday", time: "8:00 AM – 5:00 PM" },
    { day: "Saturday – Sunday", time: "Emergency Services Available" },
  ],
};

export const SERVICES = [
  {
    slug: "emergency-plumbing",
    title: "Emergency Plumbing",
    icon: "Siren",
    description:
      "24/7 rapid response for burst pipes, severe leaks, sewer backups and other urgent plumbing emergencies in Stoughton, MA.",
    bullets: ["Burst pipe response", "Overflow & flooding", "Weekend emergency available"],
  },
  {
    slug: "drain-cleaning",
    title: "Drain Cleaning",
    icon: "Droplets",
    description:
      "Professional drain snaking and hydro-jetting to clear clogs in kitchens, bathrooms, laundry lines and main sewer lines.",
    bullets: ["Kitchen & bath drains", "Main line clearing", "Hydro-jetting"],
  },
  {
    slug: "leak-detection",
    title: "Leak Detection & Repair",
    icon: "Search",
    description:
      "Non-invasive leak detection using modern equipment to pinpoint hidden leaks behind walls, under floors and underground.",
    bullets: ["Hidden leak detection", "Slab leak repair", "Water damage prevention"],
  },
  {
    slug: "water-heater",
    title: "Water Heater Install & Repair",
    icon: "Flame",
    description:
      "Tank and tankless water heater installation, repair and maintenance from licensed plumbers in Stoughton, MA.",
    bullets: ["Tankless & traditional", "Same-day repairs", "Energy-efficient options"],
  },
  {
    slug: "pipe-repair",
    title: "Pipe Repair & Replacement",
    icon: "Wrench",
    description:
      "Repair or replace copper, PEX, PVC and galvanized piping. We diagnose root causes so the fix lasts.",
    bullets: ["Copper, PEX, PVC", "Re-piping", "Frozen pipe repair"],
  },
  {
    slug: "toilet-repair",
    title: "Toilet Repair & Installation",
    icon: "Toilet",
    description:
      "From running toilets and weak flushes to full installations of modern, water-saving fixtures.",
    bullets: ["Leaks & running toilets", "New installations", "Low-flow upgrades"],
  },
  {
    slug: "faucets-fixtures",
    title: "Faucet & Fixture Installation",
    icon: "ShowerHead",
    description:
      "Sinks, faucets, shower valves, garbage disposals and other fixtures installed cleanly and to code.",
    bullets: ["Kitchen & bath faucets", "Shower valves", "Garbage disposals"],
  },
  {
    slug: "sewer-line",
    title: "Sewer Line Services",
    icon: "PipetteIcon",
    description:
      "Sewer line camera inspection, cleaning, repair and replacement. Diagnose tree-root intrusion and breaks fast.",
    bullets: ["Camera inspection", "Trenchless options", "Root removal"],
  },
  {
    slug: "commercial",
    title: "Commercial Plumbing",
    icon: "Building2",
    description:
      "Restaurants, offices, retail and multifamily properties. Scheduled maintenance and rapid service to keep operations flowing.",
    bullets: ["Restaurants & retail", "Multifamily buildings", "Preventive maintenance"],
  },
  {
    slug: "residential",
    title: "Residential Plumbing",
    icon: "Home",
    description:
      "Full-service plumbing for homeowners in Stoughton, MA. Honest pricing, clean work, and respect for your home.",
    bullets: ["Whole-home service", "Repairs & remodels", "Upfront pricing"],
  },
];

export const TRUST_INDICATORS = [
  { title: "10+ Years Experience", subtitle: "Serving MA homes & businesses", icon: "Award" },
  { title: "Licensed & Insured", subtitle: "Licensed Massachusetts plumbers", icon: "ShieldCheck" },
  { title: "Emergency Services", subtitle: "Weekend availability", icon: "Siren" },
  { title: "Serving Stoughton, MA", subtitle: "Your local plumbing team", icon: "MapPin" },
];

export const TESTIMONIALS = [
  {
    name: "Sarah M.",
    location: "Stoughton, MA",
    rating: 5,
    text:
      "Boston Express came out on a Sunday for a burst pipe. They were fast, professional, and the price was fair. Saved our basement!",
  },
  {
    name: "Daniel R.",
    location: "Stoughton, MA",
    rating: 5,
    text:
      "Replaced our old water heater with a tankless unit. Clean work, explained everything, and finished ahead of schedule.",
  },
  {
    name: "Priya K.",
    location: "Stoughton, MA",
    rating: 5,
    text:
      "Our drains had been slow for months. They cleared the main line in one visit and gave us honest advice. Highly recommend.",
  },
  {
    name: "Mike T.",
    location: "Stoughton, MA",
    rating: 5,
    text:
      "Used them for a commercial bathroom remodel. On time, on budget, and the inspector signed off without a single issue.",
  },
];

export const FAQS = [
  {
    q: "Do you offer emergency plumbing services on weekends?",
    a: "Yes. Boston Express Plumbing and Heating offers emergency plumbing services on Saturdays and Sundays in Stoughton, MA. An emergency service fee applies for after-hours and weekend calls.",
  },
  {
    q: "What areas do you serve?",
    a: "We're based in Stoughton, MA and serve homes and businesses within roughly a 20-mile radius — including Boston, Canton, Sharon, Randolph, Avon, Brockton, Easton, West Bridgewater, Bridgewater, Holbrook, Abington, Braintree, Quincy, Milton, Dedham, Norwood, Westwood, Walpole, Foxborough, Mansfield, Weymouth, Rockland, Hanover, Needham, Brookline, Newton, Medfield and Medway. Don't see your town? Give us a call — happy to help.",
  },
  {
    q: "Are you licensed and insured in Massachusetts?",
    a: "Yes. Boston Express Plumbing and Heating LLC is a fully licensed and insured plumbing company based in Stoughton, MA, with over 10 years of experience serving homeowners and businesses.",
  },
  {
    q: "Do you provide free quotes?",
    a: "Yes. We provide free, no-obligation quotes for most plumbing and heating work. Simply call us or submit the quote request form on our website and we'll get back to you quickly.",
  },
  {
    q: "Do you handle both residential and commercial plumbing?",
    a: "Absolutely. We work with homeowners, landlords, property managers, restaurants, retail spaces, offices and multifamily buildings in Stoughton, MA.",
  },
  {
    q: "How quickly can you respond to a service call?",
    a: "For emergencies, we aim to respond as quickly as possible — often within the hour in Stoughton. Standard service calls are typically scheduled the same week or next business day.",
  },
];

export const SERVICE_AREAS = [
  "Stoughton", "Boston", "Canton", "Sharon", "Randolph",
  "Avon", "Brockton", "Easton", "West Bridgewater", "Bridgewater",
  "Holbrook", "Abington", "Braintree", "Quincy", "Milton",
  "Dedham", "Norwood", "Westwood", "Walpole", "Foxborough",
  "Mansfield", "Weymouth", "Rockland", "Hanover", "Needham",
  "Brookline", "Newton", "Medfield", "Medway",
];
